function initVariantChangeForProductCard(context = document) {

  context.querySelectorAll('product-card').forEach(function(productCard) {

    if (productCard.dataset.variantChangeInit === '1') return;
    productCard.dataset.variantChangeInit = '1';

    const productId = productCard.dataset.productId;
    const pills = productCard.querySelectorAll('.size-pill[data-variant-id]');
    const variantInput = productCard.querySelector(`input[type="hidden"].variant-input-${productId}`);
    const form = productCard.querySelector(`#InlineAddToCartForm-${productId}`);
    const mainImageLink = productCard.querySelector('a.grid__image');
    const variantSelector = productCard.querySelector('.variant-selector.size-selector');
    const stockBox = productCard.querySelector('.variant-stock-alert');
    const stockQty = productCard.querySelector('.stock-quantity');

    /* ---------------- IMAGE ---------------- */

    function updateMainImage(imageSrc) {
      if (!mainImageLink) return;
      const img = mainImageLink.querySelector('img');
      if (img && imageSrc) {
        img.src = imageSrc;
        img.srcset = "";
      }
    }

    /* ---------------- ACTIVATE ---------------- */

function activatePill(pill) {

  if (!pill || pill.classList.contains('disabled')) return;

  productCard.querySelectorAll('.size-pill')
    .forEach(p => p.classList.remove('active'));

  pill.classList.add('active');

  /* ---------------- VARIANT ---------------- */

  const variantId = pill.getAttribute('data-variant-id');
  if (variantInput) variantInput.value = variantId;

  /* ---------------- IMAGE ---------------- */

  const variantImage = pill.getAttribute('data-variant-image');
  if (variantImage) updateMainImage(variantImage);

  /* ---------------- PRICE ---------------- */

  const price = pill.getAttribute('data-price');
  const compareAtPrice = pill.getAttribute('data-compare-at-price');

  const priceContainer = productCard.querySelector('.product-grid--price');
  const mainPrice = priceContainer?.querySelector('.main-price');
  const unitPriceEl = priceContainer?.querySelector('.unit-price');

  if (mainPrice) {

    if (compareAtPrice && compareAtPrice !== price) {

      mainPrice.innerHTML = `
        <span class="igComparePrice"
          style="text-decoration: line-through; color:#888; margin-right:6px;"
          data-variant-id="${variantId}">
          ${compareAtPrice}
        </span>
        <span class="igPrice"
          style="color:#FF6F00; font-weight:bold;"
          data-variant-id="${variantId}">
          ${price}
        </span>
      `;

    } else {

      mainPrice.innerHTML = `
        <span class="igPrice"
          style="color:#587D3E; font-weight:bold;"
          data-variant-id="${variantId}">
          ${price}
        </span>
      `;

    }

    const cardLinks = productCard.querySelectorAll('[data-product-card-link], a.grid__image');
    cardLinks.forEach(link => {
      const url = link.getAttribute('href');
      if (url) {
        const base = url.split('?')[0];
        link.setAttribute('href', base + '?variant=' + variantId);
      }
    });

  }

  /* ---------------- UNIT PRICE (€/kg) ---------------- */

  if (unitPriceEl) {

    const unitPrice = pill.getAttribute('data-unit-price');
    const unitMeasurement = pill.getAttribute('data-unit-price-measurement');

    if (unitPrice && unitMeasurement) {
      unitPriceEl.textContent = `(${unitPrice} / ${unitMeasurement.replace(/^1/, '')})`;
    } else {
      unitPriceEl.textContent = '';
    }

  }

  /* ---------------- STOCK ---------------- */

  const inventory = parseInt(pill.getAttribute('data-inventory'), 10);

  if (!isNaN(inventory) && inventory > 0 && inventory < 10) {

    if (stockBox && stockQty) {
      stockQty.textContent = inventory;
      stockBox.style.display = 'block';
    }

  } else {

    if (stockBox) stockBox.style.display = 'none';

  }

}

    /* ---------------- UI ADJUST ---------------- */

    if (variantSelector) {
      variantSelector.classList.toggle('few-pills', pills.length < 4);
    }

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        if (!pill.classList.contains('disabled')) {
          activatePill(pill);
        }
      });
    });

    /* ---------------- AUTO SELECT ---------------- */

    const STANDARD_KEYWORDS = [
      'standard', 'regular',
      'standardgröße', 'standardgroesse',
      'estándar', 'estandar',
      'classique', 'basique',
      'taille standard', 'unique'
    ];

    function isStandardLabel(label) {
      if (!label) return false;
      const text = label.toLowerCase();
      return STANDARD_KEYWORDS.some(k => text.includes(k));
    }

    function runAutoSelect() {

      const forcedId = productCard.dataset.forcedVariantId;
      if (forcedId) {
        const forcedPill = Array.from(pills).find(p => p.dataset.variantId === forcedId);
        if (forcedPill) { activatePill(forcedPill); return; }
      }

      let standardPill = null;

      pills.forEach(pill => {
        const label = pill.textContent?.trim();
        const isAvailable = pill.getAttribute('data-available') === 'true';
        const isDisabled = pill.classList.contains('disabled');
        const isVisible = getComputedStyle(pill).display !== 'none';

        if (isAvailable && !isDisabled && isVisible && isStandardLabel(label)) {
          standardPill = pill;
        }
      });

      if (standardPill) {
        activatePill(standardPill);
        return;
      }

      const firstAvailable = Array.from(pills).find(pill => {
        const isAvailable = pill.getAttribute('data-available') === 'true';
        const isDisabled = pill.classList.contains('disabled');
        const isVisible = getComputedStyle(pill).display !== 'none';
        return isAvailable && !isDisabled && isVisible;
      });

      if (firstAvailable) {
        activatePill(firstAvailable);
      }

    }

    // first select
    runAutoSelect();

    // again for AB
    setTimeout(runAutoSelect, 600);

    /* ---------------- AJAX ATC ---------------- */

    const addToCartBtn = form?.querySelector('.add-to-cart-btn');

    if (addToCartBtn && addToCartBtn.dataset.atcInit !== '1') {

      addToCartBtn.dataset.atcInit = '1';

      addToCartBtn.addEventListener('click', async () => {

        const variantId = variantInput?.value;
        if (!variantId) {
          alert('Please select a variant.');
          return;
        }

        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('is-loading');

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (!res.ok) throw new Error('Add to cart failed');

          const item = await res.json();

          const langPrefix = window.Shopify?.routes?.root || '';

          const sectionsRes = await fetch(
            `${langPrefix}cart?sections=cart-drawer`.replace('//', '/')
          );
          const sections = await sectionsRes.json();

          if (window.eventBus) {
            window.eventBus.emit('update:cart:drawer', {
              sections: { 'cart-drawer': sections['cart-drawer'] }
            });
            window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
          }
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          window.wetheme?.updateCartCount(cart);

        } catch (err) {
          console.error(err);
        } finally {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('is-loading');
        }
      });
    }

  });
}

/* ---------------- INIT ---------------- */

// Initial load
window.addEventListener('load', () => {
  initVariantChangeForProductCard(document);
});
customElements.whenDefined('product-card').then(() => {
  initVariantChangeForProductCard(document);
});

/* ---------------- AJAX GRID ---------------- */

function reinitCollectionGrid() {
  const grid = document.getElementById('CollectionProductGrid');
  if (grid) initVariantChangeForProductCard(grid);
}

const collectionGrid = document.getElementById('CollectionProductGrid');

if (collectionGrid) {

  let timeout;

  const observer = new MutationObserver(() => {

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      observer.disconnect();
      reinitCollectionGrid();
      observer.observe(collectionGrid, { childList: true });
    }, 50);

  });

  observer.observe(collectionGrid, { childList: true });
}
